import React from "react";
import {
	Grid,
	Typography,
	Paper,
	CircularProgress,
	Box,
} from "@material-ui/core";
import MediaItem from "./MediaItem";
import MediaUploader from "./MediaUploader";
import { PhotoLibrary } from "@material-ui/icons";
import { useMediaGridStyles } from "../utils/styles";

const MediaGrid = ({
	mediaFiles,
	loading,
	onCopy,
	resources,
	selectionMode = false,
	selectedFiles = [],
	onToggleSelection,
	onUpload,
	uploading,
	module,
}) => {
	const classes = useMediaGridStyles();

	if (loading) {
		return (
			<div className={classes.root}>
				<MediaUploader
					onUpload={onUpload}
					uploading={uploading}
					resources={resources}
					module={module}
				/>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					className={classes.loadingContainer}
					minHeight="150px"
				>
					<CircularProgress size={40} />
					<Typography variant="body2" style={{ marginTop: 16 }}>
						{resources["LoadingMedia"]}
					</Typography>
				</Box>
			</div>
		);
	}

	if (mediaFiles.length === 0) {
		return (
			<>
				<MediaUploader
					onUpload={onUpload}
					uploading={uploading}
					resources={resources}
					module={module}
				/>
				<Paper className={classes.emptyState} elevation={0}>
					<PhotoLibrary className={classes.emptyIcon} />
					<Typography variant="h6" gutterBottom>
						{resources["NoMediaFound"]}
					</Typography>
					<Typography variant="body2">
						{resources["UploadMediaToGetStarted"]}
					</Typography>
				</Paper>
			</>
		);
	}

	return (
		<div className={classes.root}>
			<MediaUploader
				onUpload={onUpload}
				uploading={uploading}
				resources={resources}
				module={module}
				style={{ marginBottom: 16 }}
			/>
			<Grid container spacing={0} className={classes.gridContainer}>
				{mediaFiles.map((media) => (
					<Grid
						item
						key={media.id}
						style={{
							width: "12.5%",
							aspectRatio: "1 / 1",
							padding: "2px",
						}}
					>
						<MediaItem
							media={media}
							onCopy={onCopy}
							resources={resources}
							selectionMode={selectionMode}
							isSelected={selectedFiles.includes(media.id)}
							onToggleSelection={onToggleSelection}
							mediaFiles={mediaFiles}
						/>
					</Grid>
				))}
			</Grid>
		</div>
	);
};

export default React.memo(MediaGrid);
